/**
 * This is where you edit what Strapi components & group map to what JSX component.
 */

import { type ReactNode } from 'react'
import LPD from '@/components/layout/LPD.tsx'
import PFG from '@/components/layout/PFG.tsx'

import { StrapiLayoutResolver } from './StrapiLayoutResolver'
import PJK from '@/components/layout/PJK.tsx'

export const StrapiRootResolver = ({ children }: { children: ReactNode }) => {
	return (
		<StrapiLayoutResolver
			// Brand Layouts/Theme Wrappers
			config={{
				lakeparkdiner: LPD,
				pjkchinese: PJK,
				paulfleminggroup: PFG,
			}}
		>
			{children}
		</StrapiLayoutResolver>
	)
}
